import { render, staticRenderFns } from "./politics.vue?vue&type=template&id=4ae82c00&"
import script from "./politics.vue?vue&type=script&lang=js&"
export * from "./politics.vue?vue&type=script&lang=js&"
import style0 from "./politics.vue?vue&type=style&index=0&id=4ae82c00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports